"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InactiveCeresTagReportSchema = exports.InactiveCeresTagAnimasSchema = exports.getAnimalReportSchema = void 0;
const zod_1 = require("zod");
//getAniamlReport
exports.getAnimalReportSchema = zod_1.z.object({
    pic: zod_1.z.array(zod_1.z.string()),
    filterCondition: zod_1.z.object({
        rfid: zod_1.z.string().optional(),
        visual_tag: zod_1.z.string().optional(),
        sex: zod_1.z.array(zod_1.z.string()).optional(),
        unit: zod_1.z.array(zod_1.z.string()).optional(),
        species: zod_1.z.array(zod_1.z.string()).optional(),
        species_type: zod_1.z.array(zod_1.z.string()).optional(),
        breed: zod_1.z.array(zod_1.z.string()).optional(),
        breed_type: zod_1.z.array(zod_1.z.string()).optional(),
        weight: zod_1.z.object({
            min: zod_1.z.number().nullable(),
            max: zod_1.z.number().nullable(),
        }).optional(),
        induction_weight: zod_1.z.object({
            min: zod_1.z.number().nullable(),
            max: zod_1.z.number().nullable(),
        }).optional(),
        pages: zod_1.z.number(),
        itemPerPage: zod_1.z.number(),
    })
});
exports.InactiveCeresTagAnimasSchema = zod_1.z.object({
    ceres_tag_esn: zod_1.z.string(),
    ceres_tag_vid: zod_1.z.string(),
    rfid: zod_1.z.string(),
    last_observed: zod_1.z.string(),
    businessName: zod_1.z.string(),
    businessId: zod_1.z.string(),
});
exports.InactiveCeresTagReportSchema = zod_1.z.object({
    animals: zod_1.z.array(exports.InactiveCeresTagAnimasSchema),
    businesses: zod_1.z.array(zod_1.z.object({
        businessId: zod_1.z.string(),
        businessName: zod_1.z.string()
    })),
    pages: zod_1.z.number(),
    itemPerPage: zod_1.z.number(),
    totalRow: zod_1.z.number(),
    totalPages: zod_1.z.number(),
});
